import InboxComponent from "@/components/inbox";

export default function Inbox() {
  return <InboxComponent />;
}
